module.exports = __webpack_public_path__ + "img/youtube.360ccac9.png";